import DateRangePicker from './DateRangePicker';
import { predefinedDateRanges } from '../DateRanges.utils';
import IsShortcutSelected from '../hooks/useShortcutSelected';
import { IPredefinedDateRanges } from '../DateRanges.model';
import { DateRangeListContainer, DateRangeListChip } from '../DateRanges.styles';
import { useState } from 'react';
import { useDateRange } from '../DateRanges.context';

const DateRangeList = () => {
  const { setDateRange } = useDateRange();
  const predefinedSelected = IsShortcutSelected();

  const [selected, setSelected] = useState<number | undefined>(predefinedSelected?.id);

  const handleChipClick = (dateRange: IPredefinedDateRanges) => {
    if (dateRange.id === selected && predefinedSelected) return;

    setDateRange(dateRange.value);

    setSelected(dateRange.id);
  };

  return (
    <DateRangeListContainer>
      {predefinedDateRanges.map(shortcut => (
        <DateRangeListChip
          key={shortcut.id}
          selected={shortcut.id === predefinedSelected?.id}
          label={shortcut.label}
          clickable
          onClick={() => handleChipClick(shortcut)}
        />
      ))}
      <DateRangePicker showAsChip />
    </DateRangeListContainer>
  );
};
export default DateRangeList;
